import React from 'react';
import { Check } from 'lucide-react';

const OUTER = '#DB9A1F';
const INNER = '#F6B9A3';

const ActionRing = ({ progress }) => {
  const radius = 48;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - Math.min(Math.max(progress, 0), 1));
  return (
    <g data-testid="ring-actions" data-progress={progress.toFixed(2)}>
      <circle cx="60" cy="60" r={radius} fill="none" stroke={OUTER} strokeOpacity="0.16" strokeWidth="22" />
      <circle
        cx="60"
        cy="60"
        r={radius}
        fill="none"
        stroke={OUTER}
        strokeWidth="22"
        strokeLinecap="butt"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        transform="rotate(-90 60 60)"
        style={{ transition: 'stroke-dashoffset 700ms cubic-bezier(0.22, 1, 0.36, 1)' }}
      />
    </g>
  );
};

const IntelDot = ({ done }) => (
  <g data-testid="ring-coaching" data-progress={done ? '1.00' : '0.00'}>
    <circle cx="60" cy="60" r="25" fill="none" stroke={INNER} strokeWidth="2" strokeDasharray="4 4" opacity={done ? 0 : 0.9} />
    <circle
      cx="60"
      cy="60"
      r="25"
      fill={INNER}
      style={{
        transformOrigin: '60px 60px',
        transform: done ? 'scale(1)' : 'scale(0)',
        transition: 'transform 500ms cubic-bezier(0.34, 1.56, 0.64, 1)',
      }}
    />
  </g>
);

const LegendRow = ({ color, label, value, done, testId }) => (
  <div className="flex items-center gap-1.5 text-[11px] sm:text-xs lg:text-sm text-stone-600 whitespace-nowrap" data-testid={testId}>
    <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ background: color }} />
    <span>{label}</span>
    <span className="font-semibold text-stone-900 flex items-center">
      {value}{done && <Check size={12} className="ml-0.5" style={{ color: OUTER }} />}
    </span>
  </div>
);

export const DailyRings = ({ actionsDone, actionsTotal, coachingDone }) => {
  const actionsProgress = actionsTotal ? actionsDone / actionsTotal : 0;
  const allClosed = actionsProgress >= 1 && coachingDone;
  return (
    <div className="bg-white border border-stone-200 rounded-xl p-3 md:p-4 h-full flex flex-col lg:flex-row items-center justify-center gap-2 lg:gap-8" data-testid="daily-rings-card">
      <div className="w-[104px] h-[104px] sm:w-[124px] sm:h-[124px] md:w-[140px] md:h-[140px] lg:w-[150px] lg:h-[150px]">
        <svg viewBox="0 0 120 120" className={`w-full h-full ${allClosed ? 'drop-shadow-[0_0_10px_rgba(219,154,31,0.5)]' : ''}`}>
          <ActionRing progress={actionsProgress} />
          <IntelDot done={coachingDone} />
        </svg>
      </div>
      <div className="space-y-0.5 lg:space-y-2">
        <LegendRow color={OUTER} label="Action" value={`${actionsDone}/${actionsTotal}`} done={actionsProgress >= 1} testId="rings-legend-actions" />
        <LegendRow color={INNER} label="Intel" value={coachingDone ? 'Received' : 'Pending'} done={coachingDone} testId="rings-legend-coaching" />
      </div>
    </div>
  );
};
